angular.module('picmonic-common').filter('integer', function () {
  return function (input) {
    if (input) {
      return parseInt(input);
    }
  };
});
